import z from "zod";

const googleAiErrorTypeValues = [
  "RESPONSE_TEXT_MISSING",
  "FAILED_TO_PARSE_SENTIMENT_RESPONSE",
  "NO_VALID_MESSAGES",
  "NO_TEXT_AFTER_IMAGE_REMOVAL",
] as const;

const googleAiErrorTypeSchema = z.enum(googleAiErrorTypeValues);
const GoogleAiErrorType = googleAiErrorTypeSchema.enum;
type GoogleAiErrorType = z.infer<typeof googleAiErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GoogleAiErrors =
  | {
      errorType: typeof GoogleAiErrorType.RESPONSE_TEXT_MISSING;
      data: {
        model: string;
        operation: "analyzeFile" | "analyzeSentiment" | "analyzeFilesForQuoting";
      };
    }
  | {
      errorType: typeof GoogleAiErrorType.FAILED_TO_PARSE_SENTIMENT_RESPONSE;
      data: {
        model: string;
        originalError: unknown;
      };
    }
  | {
      errorType: typeof GoogleAiErrorType.NO_VALID_MESSAGES;
      data: {
        originalMessageCount: number;
      };
    }
  | {
      errorType: typeof GoogleAiErrorType.NO_TEXT_AFTER_IMAGE_REMOVAL;
      data: {
        originalMessageCount: number;
      };
    };

export const googleAiErrorDetails: Record<GoogleAiErrorType, ErrorDetails> = {
  [GoogleAiErrorType.RESPONSE_TEXT_MISSING]: {
    sentryDescription: "Google AI response did not include text",
  },
  [GoogleAiErrorType.FAILED_TO_PARSE_SENTIMENT_RESPONSE]: {
    sentryDescription: "Failed to parse Google AI sentiment response",
  },
  [GoogleAiErrorType.NO_VALID_MESSAGES]: {
    sentryDescription: "Streaming chat validation removed all messages",
  },
  [GoogleAiErrorType.NO_TEXT_AFTER_IMAGE_REMOVAL]: {
    sentryDescription: "No text content remained after removing problematic images",
  },
};
